module.exports = __webpack_public_path__ + "static/media/2025_Sikuki.251a3bc2.pdf";